import React from "react";
import { ContactUsForm } from "../components/forms/ContactUsForm";
import Footer from "../components/utils/Footer";
import NavBar from "../components/utils/NavBar";

const ContactUs = () => {
  return (
    <div className="h-[100dvh] bg-black antialiased  overflow-x-hidden w-screen">
      <NavBar />
      <section className="bg-black ">
        <div
          className="py-20
         lg:py-16 px-4 mx-auto max-w-screen-md"
        >
          <h2 className="mb-4 text-5xl font-bold text-primary text-center ">
            Contact Us Form
          </h2>
          <p className="mb-8 lg:mb-16 text-center text-white  sm:text-xl">
            Got an idea you would like to bring to life? Want to price out out a
            project? Not sure where to start? Let us know, we can help.
          </p>
          <ContactUsForm />
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;
